//ruoli

export const manager = [ "81hEKYz0p6UodAb4URc7jGqKMx42","HY6e234y2ifNZ4QuNAUYAdeM0ZB2"];